export const notifications = {
	export: {
		successNotification: "Products exported to Excel",
		errorNotification: "Error exporting products to Excel",
	},
	productToggle: {
		successActivated: "Product {{productName}} was successfully activated",
		successDeactivated: "Product {{productName}} was successfully deactivated",
	},
	massActions: {
		successActivated: "Products activated successfully",
		successDeactivated: "Products deactivated successfully",
		successEdited: "Products edited successfully",
		errorEdited: "Error editing products",
		noChanges: "Select at least one field to save changes",
	},
	categoryNotFound: "Category not found. Redirecting to the first available category.",
};
